module.exports = "/_next/static/images/Hero@2x-427c4aab566434ddfc883b17ebd8d371.png";